var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box } from "@material-ui/core";
import { FTLTypography } from "../FTLTypography";
export const FTLLabel = (_a) => {
    var { label, required, variant = "h5", color = "tertiary", style } = _a, boxProps = __rest(_a, ["label", "required", "variant", "color", "style"]);
    return (React.createElement(Box, Object.assign({ mb: 2 }, boxProps, { style: Object.assign({ lineHeight: 1 }, style) }),
        React.createElement(FTLTypography, { variant: variant, color: color },
            label,
            required && React.createElement("span", { style: { color: "#e6360f" } }, "*"))));
};
//# sourceMappingURL=index.js.map